import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_54f7kuhpda: FaireBrandEntity = {
  token: "b_54f7kuhpda",
  type: "brand",
  name: "Dermstreet",
  avatarUrl:
    "https://cdn.faire.com/fastly/078eee1ef76deeb53b00d1aa0c113a109e4161c87d544a2f11a723f95afd42b2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c22f779fa2278e6b7e8e892583225a68652331005626c4d90bae2f076ebc6351.png",
  logoUrl:
    "https://cdn.faire.com/fastly/078eee1ef76deeb53b00d1aa0c113a109e4161c87d544a2f11a723f95afd42b2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c22f779fa2278e6b7e8e892583225a68652331005626c4d90bae2f076ebc6351.png",
  location: "New Rochelle, NY, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 64,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to DermStreet, your premier destination for medical skincare products. With over a decade of experience in sourcing the finest skincare solutions, our mission is to deliver the best products on the market directly to you, the consumer.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:29.267Z",
    importedBy: "entity-db-cli",
  },
};
